import { render, staticRenderFns } from "./solutions.vue?vue&type=template&id=4fbe72e0&scoped=true"
import script from "./solutions.vue?vue&type=script&lang=js"
export * from "./solutions.vue?vue&type=script&lang=js"
import style0 from "./solutions.vue?vue&type=style&index=0&id=4fbe72e0&prod&lang=scss&scoped=true"
import style1 from "./solutions.vue?vue&type=style&index=1&id=4fbe72e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe72e0",
  null
  
)

export default component.exports